import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { BiArrowBack } from 'react-icons/bi'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'

import styles from './TopSection.module.scss'
import PropTypes from 'prop-types'

const PATH_TITLE = {
  '/patients': 'Patients',
  '/users': 'Users',
  '/alerts': 'Alerts',
  '/care-plans': 'Care Plans',
  '/surveys': 'Questionnaires',
  '/questionnaires': 'Questionnaires',
  '/flow-sheets': 'Flow Sheets',
  '/files': 'Files',
  '/clinic': 'Clinic',
  '/portals': 'Portals'
}

function deriveTitle (pathname, explicitTitle) {
  if (explicitTitle != null && explicitTitle !== '') return explicitTitle
  const match = Object.keys(PATH_TITLE).find(
    (p) => pathname === p || pathname.startsWith(`${p}/`)
  )
  return match ? PATH_TITLE[match] : ''
}

const TopSection = ({
  title,
  btnFunction,
  isDisabled,
  showNew,
  onBack,
  hidePrimaryButton
}) => {
  const location = useLocation()
  const [btnText, setBtnText] = useState('')

  const resolvedTitle = deriveTitle(location.pathname, title)

  useEffect(() => {
    let tempText = ''
    if (location.pathname === '/patients' && !showNew) {
      tempText = 'Enroll a New Patient'
    } else if (
      (location.pathname === '/questionnaires' || location.pathname === '/surveys') &&
      !showNew
    ) {
      tempText = 'New Questionnaire'
    } else if (location.pathname === '/flow-sheets' && !showNew) {
      tempText = 'New Flow Sheet'
    } else if (location.pathname === '/files' && !showNew) {
      tempText = 'New file'
    } else if (location.pathname === '/clinic' && !showNew) {
      tempText = 'New Practitioner'
    } else if (location.pathname === '/care-plans' && !showNew) {
      tempText = 'New Care Plan'
    } else if (location.pathname === '/organization' && !showNew) {
      tempText = 'New Organization'
    } else if (location.pathname === '/portals' && !showNew) {
      tempText = 'New Portal'
    }
    setBtnText(tempText)
  }, [location.pathname, showNew])

  const showBack = showNew || Boolean(onBack)

  const handleBack = () => {
    if (onBack) onBack()
    else if (btnFunction) btnFunction(null, false)
  }

  const handlePrimary = () => {
    if (btnFunction) btnFunction(null, true)
  }

  const showPrimary = !hidePrimaryButton && btnText && !showNew

  return (
    <header className={styles['page-header']}>
      <div className={styles['page-header__inner']}>
        <div className={styles['page-header__left']}>
          {showBack && (
            <BiArrowBack
              role="button"
              aria-label="Back"
              onClick={handleBack}
              className={styles['page-header__back']}
              style={{
                opacity: isDisabled ? 0.4 : 1,
                pointerEvents: isDisabled ? 'none' : 'auto'
              }}
            />
          )}
          {resolvedTitle && (
            <Typography
              variant="h6"
              component="h1"
              className={styles['page-header__title']}
            >
              {resolvedTitle}
            </Typography>
          )}
        </div>
        {showPrimary && (
          <div className={styles['page-header__right']}>
            <Button
              variant="contained"
              onClick={handlePrimary}
              disabled={isDisabled}
            >
              {btnText}
            </Button>
          </div>
        )}
      </div>
    </header>
  )
}

TopSection.defaultProps = {
  title: '',
  isDisabled: false,
  showNew: false,
  onBack: null,
  hidePrimaryButton: false
}

TopSection.propTypes = {
  title: PropTypes.string,
  btnFunction: PropTypes.func,
  isDisabled: PropTypes.bool,
  showNew: PropTypes.bool,
  onBack: PropTypes.func,
  hidePrimaryButton: PropTypes.bool
}

export default TopSection
